<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <v-flex mb-4 xs12>
          <h1>Member Code</h1>
          <h1>멤버 코드</h1>
          Send this ({{full_link_code.length}}) character code to your team leader.  
          <br/>
          아래 ({{full_link_code.length}})자리 코드를 
          <br/>그룹 리더(그룹 패스 신청자)에게 보내주세요.
      </v-flex>
      <v-flex mb-4 xs12 text-xs-center>
          <div class='event_profile_code' my-4>
              {{full_link_code}}
          </div>
      </v-flex>
      <v-flex mt-4 xs12>
          <v-btn :to="`/events/${event.id}`">OK</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
import {mapState} from 'vuex';

export default {
  data: () => ({event: {}, full_link_code: '--'}),
  beforeMount: async function() {
    await this.$store.dispatch('loadEvents');
    await this.$store.dispatch('loadAttendees');
    this.show_event();
    this.determine_full_link_code();
  },
  computed: {
    ...mapState(['myprofile', 'events', 'attendees']),
  },
  watch: {
    events(to, from) {
      this.show_event();
    },
    attendees(to, from) {
      this.determine_full_link_code();
    },
  },
  methods: {
    show_event() {
      this.$data.event = this.events?.find(x => {
        return x.id == this.$route.params.event_id;
      });
    },
    determine_full_link_code() {
      let at = this.attendees?.find(x => {
        return x.event_id == this.$route.params.event_id;
      });
      this.$data.full_link_code = at?.full_link_code;
    },
  },
};
</script>

<style>
.event_profile_code {
  font-size: 3em;
  padding: 1em;
  border: 0px solid black;
}
</style>
